import { app } from '../../../../app';
import { Controller } from './license-invoices.controller';

app.component('licenseInvoices', {
    bindings:{
        invoices: '<',
    },
    controller: Controller,
    templateUrl: require('./license-invoices.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/invoices/license-invoices.component.js